import React from 'react'
import getAllFocusableElements from 'common/helpers/getters/getAllFocusableElements'
import { Message } from 'sb-react-intl'
import { useCallback } from 'sb-hooks'

import VisuallyHidden from 'components/ui/VisuallyHidden/VisuallyHidden'
import { Href } from 'components/_new/controls'

import messages from './messages'


type SkipContentProps = {
  contentId: string
  skipContentTitle?: 'queue' // mbe additional keys will be added
}

const SkipContent: React.FunctionComponent<SkipContentProps> = ({ contentId, skipContentTitle }) => {
  const text = skipContentTitle === 'queue' ? messages.skipQueueTitle : messages.title

  const handleClick = useCallback((event) => {
    event.preventDefault()

    const mainContentEl           = document.getElementById(contentId)
    const mainContentFocusableEls = getAllFocusableElements(mainContentEl)
    const firstFocusableEl        = mainContentFocusableEls[0]

    if (firstFocusableEl) {
      firstFocusableEl.focus()
    }
  }, [ contentId ])

  return (
    <VisuallyHidden>
      <Href href={`#${contentId}`} onClick={handleClick}>
        <Message text={text} />
      </Href>
    </VisuallyHidden>
  )
}


export default SkipContent
